import React from "react";
import { useBreakpoint, Button } from "./oneui";
import { COLORS } from "Config/tailwind"

const buttonTextProps = {
  variant: "P2",
  weight: "semi-bold",
  className: "twside-text-green-gray-500"
}


export const DateRangeButton = React.forwardRef(
    ({ open, label, startIcon, ...rest }, ref) => {
      const isMobile = useBreakpoint("m");
      return (
        <Button
          ref={ref}
          allowClickPropogation={true}
          startIcon={{
            size: "s",
            type: "calender",
            color: COLORS['green-gray'][500]
          }}
          variant="TOOLS"
          size="large"
          endIcon={{
                  size: "xs",
                  type: "down-arrow",
                  className: open ? "twside-rotate-[180deg]" : "",
                  color: COLORS['green-gray'][500]
                }
          }
          buttonTextProps={buttonTextProps}
          className="!twside-bg-white hover:!twside-bg-primary-50"
          {...rest}
        >
          {label}
        </Button>
      );
    }
  );
  
export const FilterButton = React.forwardRef(
  ({ open, label, startIcon, ...rest }, ref) => {
    const isMobile = useBreakpoint("m");
    return (
      <Button
        ref={ref}
        allowClickPropogation={true}
        startIcon={{
          size: "s",
          type: "filter",
          color: COLORS['green-gray'][500]
        }}
        variant="TOOLS"
        size="large"
        endIcon={
          isMobile
            ? null
            : {
                size: "xs",
                type: "down-arrow",
                className: open ? "twside-rotate-[180deg]" : "",
                color: COLORS['green-gray'][500]
              }
        }
        buttonTextProps={buttonTextProps}
        className="!twside-bg-white hover:!twside-bg-primary-50"
        {...rest}
      >
        {!isMobile && "Filter"}
      </Button>
    );
  }
);